// import { createNonceStr, md5 } from '@/utils/utils'
import request from '@/utils/request'

import sign from '@/utils/sign'
import {checkCodeApi} from '@/api'
export const sendPhoneCode = (phoneNum) => {
  return new Promise((resolve) => {
    //签名
    request.get(checkCodeApi + phoneNum, { type: 1 }, {
      ...sign.sign_share
    })
    .then( (data) => {
      resolve(data);
    } )
  })
}